import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { WIDGET, } from '@voltmoney/schema';
import { appendURlWithParam, isAccessTokenStale, isMobile, setAppHeader, } from '../../configs/utils';
import { ACTION } from "../partnerWeb_Dashboard/types";
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { SideBarBuilderDS } from "../sideNavBar";
import { onChangeTab, onDownLoadEarningReport, openMenu, promoBannerInvite } from "./action";
import { BottomNavBuilderDS } from "../bottomNav";
import { GoToFaq, GoToHome, GoToPhone } from "../partnerSignUp/actions";
import { handleConnection, onLogoutPress } from "../partnerWeb_Dashboard/actions";
import { checkIfPartnerDetailsAdded, ShowNewRmContactButton } from "../partnerWeb_Dashboard/utils";
import { partnerApi, StoreKey } from "../../configs/api";
import { onShareLinkWithRef } from "../leads/actions";
import sharedPropsService from "../../SharedPropsService";
import { initializeFirebase } from "../../configs/config";
import { getAppHeader } from '../../configs/config';
import { VoltWebSiteBaseLink } from '../../configs/constants';
const _isMobile = isMobile();
export const template = async (partnerAccountType, partnerAccountID, earningReportMonth, showNewRmContactButton, rmData, height, isFromMobile) => ({
    layout: {
        id: ROUTE.INTEREST_CALCULATOR,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            !isMobile()
                ? {
                    id: 'sideNav',
                    type: WIDGET.STACK,
                    position: POSITION.NAVBAR_LEFT,
                }
                : {},
            { id: 'InterestCalculatorPageMainStack', type: WIDGET.PARTNER_INTEREST_CALCULATOR },
            isFromMobile ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ]
    },
    datastore: {
        rmContactButton: {
            title: 'Contact us',
            rmData,
            handleRmConnection: {
                routeId: ROUTE.INTEREST_CALCULATOR,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        ...await PartnerHeader(ROUTE.INTEREST_CALCULATOR),
        ...await SideBarBuilderDS(ROUTE.INTEREST_CALCULATOR),
        ...await BottomNavBuilderDS(ROUTE.INTEREST_CALCULATOR),
        InterestCalculatorPageMainStack: {
            height: height,
            shareLinkAction: {
                routeId: ROUTE.INTEREST_CALCULATOR,
                type: ACTION.SHARE_LINK_REF,
                payload: {}
            },
            baseLink: VoltWebSiteBaseLink
        }
    },
});
export const InterestCalculatorMf = {
    onLoad: async ({ asyncStorage, network, instrumentTrack, openNewTab, getHeight, ...props }, { action }) => {
        await checkIfPartnerDetailsAdded({ network: network, openNewTab: openNewTab });
        await setAppHeader();
        await initializeFirebase();
        const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        let partnerAccountType = undefined;
        let partnerAccountID;
        const earningReportMonth = await sharedPropsService.getFirebaseConfig()?.earnings_report_month;
        appendURlWithParam('interest-calculator');
        if (await isAccessTokenStale({ asyncStorage: asyncStorage,
            network: network })) {
            partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
            partnerAccountID = _user?.linkedPartnerAccounts[0]?.accountId;
        }
        else {
            partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
            partnerAccountID = _user?.linkedPartnerAccounts[0]?.accountId;
        }
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const header = await getAppHeader();
        const isFromMobile = isMobile();
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountID}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        return Promise.resolve(template(partnerAccountType, partnerAccountID, earningReportMonth, showNewRmContactButton, rmData, getHeight(), isFromMobile));
    },
    actions: {
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: promoBannerInvite,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.SHARE_LINK_REF]: onShareLinkWithRef,
        [ACTION.DOWNLOAD_EARNING_REPORT]: onDownLoadEarningReport,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
    }
};
